import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { getSignCode, TeamToPhoneNumber, servedCountriesList } from 'src/app/domains/internal-facilities/email-signature/models';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';

const imageUrlPrefix: string = 'https://drive.google.com/thumbnail?id=';
const defaultImageUrl: string = 'https://drive.google.com/thumbnail?id=10GOxvMC3uopKPB-EzwEyBljfOVii0rb2';
const defaultName: string = 'Gabriele Proni';
const defaultRole: string = 'CTO';
const defaultCountry: string = servedCountriesList[0];

@Component({
    selector: 'gdp-email-signature',
    templateUrl: './email-signature.component.html',
    styleUrls: ['./email-signature.component.scss']
})
export class EmailSignatureComponent implements OnInit {

    dataForm: UntypedFormGroup;
    safeSignature: SafeHtml;
    signature: string;
    teams: string[] = Object.keys(TeamToPhoneNumber[defaultCountry]);
    selectedTeam = this.teams[0];
    public countries: string[] = servedCountriesList;
    public selectedCountry: string = defaultCountry;
    @ViewChild('htmlSign', { static: false }) htmlSignTextarea: ElementRef;

    constructor(
      private sanitizer: DomSanitizer,
      private notification: NotificationService,
      private utilsService: UtilsService
    ) { }

    ngOnInit() {
        this.dataForm = new UntypedFormGroup({
            'imageUrl': new UntypedFormControl('', Validators.required),
            'name': new UntypedFormControl('', Validators.required),
            'role': new UntypedFormControl('', Validators.required)
        });
        // Starting preview with gab data
        this.signature = getSignCode(
            defaultImageUrl,
            defaultName,
            defaultRole,
            TeamToPhoneNumber[this.selectedCountry][this.selectedTeam]
        );
        this.safeSignature = this.sanitizer.bypassSecurityTrustHtml(this.signature);
    }

    generateSign() {
        if (this.dataForm.valid) {
            // Little code to accept both the url generate from GDrive when generate share link is selected
            // and just the id
            let id: string = this.dataForm.value.imageUrl;
            if (/drive\.google/.test(id)) {
                //differentiate between the link generated from gdrive and the
                // thumbnail copied
                if (/thumbnail/.test(id)) {
                    // https://drive.google.com/thumbnail?id=10GOxvMC3uopKPB-EzwEyBljfOVii0rb2
                    // [https://drive.google.com/] [id=10GOxvMC3uopKPB-EzwEyBljfOVii0rb2]
                    let splitId = id.split('thumbnail?');
                    // [id] [10GOxvMC3uopKPB-EzwEyBljfOVii0rb2]
                    splitId = splitId[1].split('=');
                    id = splitId[1];
                } else {
                    const splitId = id.split('/');
                    id = splitId[splitId.findIndex(el => el === 'd') + 1];
                }
            }
            this.signature = getSignCode(
                imageUrlPrefix + id,
                this.dataForm.value.name,
                this.dataForm.value.role,
                TeamToPhoneNumber[this.selectedCountry][this.selectedTeam]
            );
            this.safeSignature = this.sanitizer.bypassSecurityTrustHtml(this.signature);
        }
    }

  copyImage() {
      this.utilsService.copyToClipboard(
        this.signature,
        'text/html',
        () => {
          this.notification.success('internal-facilities.email-signature.notifications.copied-from-image');
        }
      );
  }

    copyHTML() {
        this.utilsService.copyToClipboard(
          this.signature,
          'text/plain',
          () => {
            this.notification.success('internal-facilities.email-signature.notifications.copied-from-code');
          }
        );
    }

    isInvalid(name: string): boolean {
        return this.dataForm.get(name).invalid && this.dataForm.get(name).dirty;
    }

    onChangeTeam(team: string): void {
        this.selectedTeam = team;
    }

    onChangeCountry(country: string): void {
        this.selectedCountry = country;
        this.teams = Object.keys(TeamToPhoneNumber[country]);
        this.selectedTeam = this.teams[0];
    }
}
